import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';

import { Button } from '@/components/ButtonComponent';
import { textVariants } from '@/components/lib/typography';

type ViewAltLinesButtonProps = {
    onPress: () => void;
    testID?: string;
};

export const ViewAltLinesButton = ({ onPress, testID }: ViewAltLinesButtonProps) => {
    const { t } = useTranslation(['common']);
    return (
        <Button
            shape="pill"
            variant="outline"
            label={t('view_alternate_lines')}
            onPress={onPress}
            size="m"
            style={styles.button}
            textStyle={textVariants.labelLarge2}
            testID={testID}
        />
    );
};

const styles = StyleSheet.create({
    button: {
        height: 40,
    },
});
